'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { formatGermanNumber } from '@utils/utils-format';
import type { ProductReviewSummary } from 'src/lib/trusted-shops/product-reviews';
import { RatingStars } from 'src/shared/composites/trusted-shops/rating-stars';
import { fetchExperienceRating } from '../lib/fetch-experience-rating';
export function ExperienceCardRating(t0) {
  const $ = _c(13);
  const {
    publicId
  } = t0;
  let t1;
  if ($[0] !== publicId) {
    t1 = {
      queryKey: ["experience-rating", publicId],
      queryFn: () => fetchExperienceRating(publicId),
      staleTime: 3600000,
      retry: false,
      refetchOnWindowFocus: false
    };
    $[0] = publicId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data
  } = useQuery(t1);
  if (!data?.count) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <div className="h-5" aria-hidden={true} />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  const t2 = `Trusted Shops: ${formatGermanNumber(Math.round(data.rating * 10) / 10)} von 5, ${data.count === 1 ? "eine Bewertung" : `${formatGermanNumber(data.count)} Bewertungen`}`;
  let t3;
  if ($[3] !== data.rating) {
    t3 = <RatingStars rating={data.rating} />;
    $[3] = data.rating;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== data.count) {
    t4 = formatGermanNumber(data.count);
    $[5] = data.count;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <span className="whitespace-nowrap font-body-small">({t4})</span>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
    t6 = <div className="flex h-5 items-center gap-[7px]" role="img" aria-label={t2}>{t3}{t5}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}